import { AxiosInstance } from 'axios';
import { errorHandler } from './errorHandler/errorHandler';
import { cacheGet } from './cache';

export default (axios: AxiosInstance) => ({
  search: async (query: SearchMedicineQuery) => {
    const url = `/api/v1/medicine`;
    return errorHandler<Medicine[]>(
      axios.get(url, { params: query }),
      'medicine - search',
      { query, url }
    );
  },
  getAtcCode: async (atcCode: string, query: GetMedicineByAtcCodeQuery) => {
    const url = `/api/v1/medicine/atc-code/${atcCode}`;
    return errorHandler<Medicine[]>(
      axios.get(url, { params: query }),
      'medicine - getByAtc',
      { query, url }
    );
  },
  getCountries: async () => {
    const url = `/api/v1/medicine/available-countries`;
    return errorHandler(
      cacheGet<string[]>(axios, 'MEDICINE:getCountries')(url),
      'medicine - getCountries',
      { url }
    );
  },
  getVmpsByAtcCode: async (
    atcCode: string,
    language: string,
    query: GetVmpsByAtcCodeQuery
  ) => {
    const url = `/api/v1/medicine/vmp/atc-code/${atcCode}`;
    return errorHandler(
      axios.get<VmpSummary[]>(url, {
        headers: { 'Accept-language': language },
        params: query,
      }),
      'medicine - getVmpsByAtcCode',
      { url }
    );
  },
});
